import { bitcoinTestnet } from '@reown/appkit/networks';
export const BitcoinApi = {
    getUTXOs: async ({ network, address }) => {
        const isTestnet = network.caipNetworkId === bitcoinTestnet.caipNetworkId;
        // Make chain dynamic
        const response = await fetch(`https://mempool.space${isTestnet ? '/testnet' : ''}/api/address/${address}/utxo`);
        if (!response.ok) {
            throw new Error(`Failed to fetch UTXOs: ${await response.text()}`);
        }
        return (await response.json());
    }
};
//# sourceMappingURL=BitcoinApi.js.map